import type { ShopStats } from '@/types/common';
import { useFetch } from '@vueuse/core';
import { defineStore } from 'pinia';
import { computed } from 'vue';

export const useStatsStore = defineStore('stats', () => {
  const url = computed(() => window.route('shop.stats'));

  const { data, error, isFetching: pending, execute } = useFetch<ShopStats>(
    url,
    {
      immediate: false,
      refetch: false,
      beforeFetch: ({ options }) => {
        options.headers = {
          ...options.headers,
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        };
        options.credentials = 'same-origin';
        return { options };
      },
      afterFetch: (ctx) => {
        return ctx;
      },
      onFetchError: (ctx) => {
        ctx.data = {
          gmv: '0',
          aov: '0',
          orders: 0,
        };
        return ctx;
      },
    },
  ).json();

  const stats = computed(() => data.value);

  async function fetchStats() {
    if (pending.value || data.value) {
      return;
    }
    await execute();
  }

  return {
    stats,
    pending,
    error,
    fetchStats,
  };
});
